import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, HostListener } from '@angular/core';
import { GlobalQuestionService } from '../../services/global-question.service';
import { FlowPageDataPerson, FlowPageDataProduct, FlowProduct, QuoteCollation } from '../../models/quote.model';
import { QuestionFlowSessionQuery } from '../../questions/state/question-flow-session.query';
import { Question } from '../../models/underwriter.model';
import { AnimationOptions } from 'ngx-lottie';
import { EntryType, QuestionType, RouterLinks } from '../../constants';
import { FlowPlayerService } from '../../services/flow-player.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionStore } from '../../questions/state/question.store';
import { QuestionFlowSessionStore } from '../../questions/state/question-flow-session.store';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { PolicyQuery } from 'src/app/modules/policy/state/policy.query';
import { Policy } from '../../models/policy.model';
import { PolicyService } from 'src/app/modules/policy/services/policy.service';
import { PausePolicyComponent } from '../policy-actions/pause-resume-policy/pause-policy/pause-policy.component';
import { CancelPolicyComponent } from '../policy-actions/cancel-restore-policy/cancel-policy/cancel-policy.component';
import { ResumePolicyComponent } from '../policy-actions/pause-resume-policy/resume-policy/resume-policy.component';
import { RestorePolicyComponent } from '../policy-actions/cancel-restore-policy/restore-policy/restore-policy.component';
import { Alert, getIndex, scrollToItem} from '../../utilities';
import { DatePipe } from '@angular/common';
import { PolicyStore } from 'src/app/modules/policy/state/policy.store';
import { Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';



declare const $: any;
declare const accounting: any;
declare function editModalGuides(): any;
declare function isElementInViewport(el: Element): boolean;

class EditModalCategories {
  class_id: number;
  class_name: string;
  collations: QuoteCollation[];
}
enum Entity {
  Policy = 'Policy',
  Item = 'Item',
  Vap = 'Vap'
}
@Component({
    selector: 'app-edit-modal',
    templateUrl: './edit-modal.component.html',
    styleUrls: ['./edit-modal.component.scss'],
    standalone: false
})
export class EditModalComponent implements OnInit, OnChanges {
  @Input() collation: QuoteCollation;
  @Input() isEdit: false;
  @Input() collations: QuoteCollation[] = [];
  @Input() product: FlowPageDataProduct;
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() reload = new EventEmitter<any>();
  @ViewChild('pausePolicyComponent', { static: false }) pausePolicyComponent: PausePolicyComponent;
  @ViewChild('cancelPolicyComponent', { static: false }) cancelPolicyComponent: CancelPolicyComponent;
  @ViewChild('resumePolicyComponent', { static: false }) resumePolicyComponent: ResumePolicyComponent;
  @ViewChild('restorePolicyComponent', { static: false }) restorePolicyComponent: RestorePolicyComponent;
  @HostListener('document:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closeEditModal();
    }
  }
  questions: Question[] = [];
  childrenQuestions: Question[] = [];
  sessionDetails: any;
  loading = false;
  loaderOptions: AnimationOptions = {
    path: 'assets/everything-insure-loader.json',
  };
  QuestionType = QuestionType;
  readonly = false;
  accounting: any;
  products: FlowProduct[] = [];
  person: any;
  categories: EditModalCategories[] = [];
  question: any;
  path = '3';
  platform_fee: any;
  taxes: any;
  isSavingData = false;
  isCalcPremLoading = false;
  activeItemId = '';
  activeClassId = 0;
  editModalEl = '#edit-modal';
  moreQuestions: any;
  confirmChangesGuide: any;
  editModal: any;
  editModalBackdrop: any;
  editModalContent: any;
  editModalReview: any;
  frequency_id = 3;
  classes: any = [];
  items: any = [];
  benefits: any = [];
  fees = '';
  selectedItem: any;
  addons: any = [];
  policy: Policy;
  tempPolicyId = '';
  tempPolicySessionId = '';
  newPolicySessionId = '';
  selectedtQuestions: any;
  dependentQuestions = [];
  currentQuestion: any;
  answeredQuestions = [];
  itk: any;
  selectedEntity: any;
  selectedVap: any;
  Entities = Entity;
  changes: any;
  changeProduct: any;
  changeItems: any = [];
  changeBenefits: any;
  changeUW: any;
  included: any = [];
  vap = {
    name: '',
    description: '',
    price: 0,
    type: '',
    details: []
  }
  objectKeys = Object.keys;
  inceptionDates: any;
  premiumCollation: any;
  uw_collation: any;
  item_uw_collation: any = [];
  json_data: any = [];
  newItem: any;
  processing = false;
  item: any;
  questionChanged = false;
  policyHolder: any;
  selectedFilter = 'All insured items';
  locations: any;
  locationData: any;
  itemCount = 0;
  menuState = 'select-active';
  status_id = 1;
  inceptionDate: any = new Date().toISOString().split('T')[0];
  inceptionDateChanged = false;
  private policyChangeCheck$ = new Subject<void>();
  private questionsRefresh$ = new Subject<void>();
    constructor(
    public globalQuestionService: GlobalQuestionService,
    private router: Router,
    private policyQuery: PolicyQuery,
    private policyStore: PolicyStore,
    private flowPlayer: FlowPlayerService,
    private ref: ChangeDetectorRef,
    private questionStore: QuestionStore,
    private userStore: UserStore,
    private policyService: PolicyService,
    public datePipe: DatePipe,
    private questionFlowSessionStore: QuestionFlowSessionStore,
    private questionFlowSessionQuery: QuestionFlowSessionQuery
  ) {
    this.sessionDetails = this.questionFlowSessionQuery.getValue();
  }

  ngOnInit(): void {
    this.globalQuestionService.summaryData.subscribe(x => this.isSavingData = x);
    this.person = this.userStore.getValue();
    accounting.settings = {
      currency: {
        symbol: this.item?.currency + ' ' || 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
    this.initModal();
    this.switchEditModalState('select-active');

    this.policyChangeCheck$.pipe(
      debounceTime(500),
      switchMap(() => this.policyService.checkPolicyChanges(this.item?.session_id))
    ).subscribe(changes => {
      const hasChanges = !!changes?.length && changes[0]?.result === 1;
      if (hasChanges) {
        $('#edit-modal-changes-notice-demo').removeClass('d-none');
      } else {
        $('#edit-modal-changes-notice-demo').addClass('d-none');
      }
    });

    // After an EI-product answer save the backend can recalculate other questions' values.
    // Refetch the session's questions (debounced so a burst of edits is one call; switchMap
    // so a stale refetch is cancelled by a newer one) and merge only the questions whose
    // answer actually changed, giving each a new object reference so its control re-renders.
    this.questionsRefresh$.pipe(
      debounceTime(400),
      switchMap(() => {
        const parameters = new Map<string, string>();
        parameters.set('session_id', this.item?.session_id);
        parameters.set('person_id', this.person?.person_id?.toString());
        return this.globalQuestionService.runCommandNew('getQuestions', parameters);
      })
    ).subscribe((fresh: Question[]) => {
      if (!this.item || !fresh?.length) {
        return;
      }
      this.questions = this.questions.map(existing => {
        const updated = fresh.find(f => f?.cent_aq_question_id === existing?.cent_aq_question_id
          && f?.item_id === existing?.item_id);
        return (updated && updated.answer !== existing.answer) ? { ...updated } : existing;
      });
      // rebuild the active item's questions off the refreshed list; the location case (1230)
      // is sourced from locationData, not getQuestions, so it is left untouched
      if (this.selectedItem && this.selectedItem?.cent_aq_question_id !== 1230) {
        this.selectedtQuestions = this.getQuestions(this.selectedItem?.class_id, this.selectedItem?.session_item_id);
      }
      this.ref.detectChanges();
    }, error => {
      console.log(error);
    });
  }
 
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.collation?.currentValue !== changes?.collation?.previousValue) {
      this.collation = changes?.collation?.currentValue;
    }
    if (changes?.collations?.currentValue !== changes?.collations?.previousValue) {
      this.collations = changes?.collations?.currentValue;
      this.collation = this.collations?.find(col => col.class_id === this.activeClassId &&
        col.session_item_id === this.activeItemId &&
        col.entry_type === EntryType.item &&
        col.product_id === this.product?.product_id &&
        col.frequency_id === this.globalQuestionService?.currency?.frequency_id);

    }
    if (changes?.product?.currentValue !== changes?.product?.previousValue) {
      this.product = changes?.product?.currentValue;
    }
    try { this.item.bank_details = JSON.parse(this.item?.bank_details)[0] || []; } catch { }

    this.getClasses();
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.item.session_id);
    parameters.set('person_id', this.person?.person_id.toString());
    this.globalQuestionService.runCommandNew(`getQuestions`, parameters).subscribe(questions => {
      console.log(questions);
      this.questions = questions;
      this.globalQuestionService.spinner(false);
    }, error => {
      console.log(error);
      $('#error-modal').modal('show');
      this.globalQuestionService.spinner(false);
    });
  }

  initModal(): void {
    this.editModal = document.querySelector('.edit-modal');
    this.editModalContent = this.editModal.querySelector('.edit-modal__content');
    this.editModalBackdrop = this.editModal.querySelector('.edit-modal__backdrop');
    this.editModalReview = this.editModal.querySelector('.edit-modal__review');
    this.confirmChangesGuide = null;

    //this.confirmChangesGuide = new editModalGuides();

    //this.confirmChangesGuide.init(null, 1, true) 

    let exitAlert = false; // can exit edit modal without warning modal
    this.editModalBackdrop.addEventListener('click', () => this.closeEditModal());
    const searchBtns = document.querySelectorAll('.edit-modal__filters-search');

    // listen for search open
    searchBtns.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();

        const target = document.getElementById(el.getAttribute('data-target'));
        target.classList.add('is-active');

        // focus input
        target.querySelector('input').focus();

        let navItems = el.closest('.edit-modal__content-wrap')
          .querySelector('.edit-modal__content-body .edit-nav--items');

        //demoSearchNavItems(navItems, target.querySelector('input'));

      });
    });

    // listen for search close
    const searchCloseBtns = document.querySelectorAll('.edit-modal__search-close');
    searchCloseBtns.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();

        const target = el.closest('.edit-modal__search');
        target.classList.remove('is-active');

        let navItems = el.closest('.edit-modal__content-wrap')
          .querySelector('.edit-modal__content-body .edit-nav--items');

        //resetSearchNavItems(navItems, target.querySelector('input'));
      });
    });
    if (this.isEdit) {
      $('#edit-modal-changes-tray-demo').removeClass('d-none');
    }
    this.initFilters();
  }
  initFilters(): void {
    
    function demoSearchToggle() {
      const searchBtns = document.querySelectorAll(".edit-modal__filters-search")

      // listen for search open
      searchBtns.forEach(function (el) {
        el.addEventListener("click", function (e) {
          e.preventDefault()

          const target = document.getElementById(el.getAttribute("data-target"))
          target.classList.add("is-active")

          // focus input
          target.querySelector("input").focus()

          let navItems = el.closest(".edit-modal__content-wrap").querySelector(".edit-modal__content-body .edit-nav--items")

          demoSearchNavItems(navItems, target.querySelector("input"))
        })
      })

      // listen for search close
      const searchCloseBtns = document.querySelectorAll(".edit-modal__search-close")
      searchCloseBtns.forEach(function (el) {
        el.addEventListener("click", function (e) {
          e.preventDefault()

          const target = el.closest(".edit-modal__search")
          target.classList.remove("is-active")

          let navItems = el.closest(".edit-modal__content-wrap").querySelector(".edit-modal__content-body .edit-nav--items")

          resetSearchNavItems(navItems, target.querySelector("input"))
        })
      })
    }

    function demoSearchNavItems(navItems, input) {
      // on input change, search each list item for a match and hide the rest
      input.addEventListener("input", function (e) {
        let search = e.target.value.toLowerCase()
        let items = navItems.querySelectorAll("li")

        if (search.length < 1 && search !== "") return

        // hide all parent groups on valid input
        navItems.querySelectorAll(".edit-nav__group").forEach(function (group) {
          group.classList.add("d-none")
        })

        items.forEach(function (item) {
          let text = item.textContent.toLowerCase()
          let match = text.includes(search)

          if (match) {
            // unhide parent group if match
            item.closest(".edit-nav__group").classList.remove("d-none")
            item.classList.remove("d-none")
          } else {
            item.classList.add("d-none")
          }
        })
      })
    }

    function resetSearchNavItems(navItems, input) {
      // clear input
      input.value = ""

      // reset all nav items to visible
      navItems.querySelectorAll("li").forEach(function (item) {
        item.classList.remove("d-none")
      })

      // reset all parent groups to visible
      navItems.querySelectorAll(".edit-nav__group").forEach(function (group) {
        group.classList.remove("d-none")
      })
    }

    function demoSortToggle() {
      const sortBtns = document.querySelectorAll(".edit-modal__filters-sort")

      // listen for sort toggle
      sortBtns.forEach(function (el) {
        el.addEventListener("click", function (e) {
          e.preventDefault()

          let navItems = el.closest(".edit-modal__content-wrap").querySelector(".edit-modal__content-body .edit-nav--items")

          // toggle between is-desc and is-asc
          if (el.classList.contains("is-desc")) {
            el.classList.remove("is-desc")
            el.classList.add("is-asc")
            demoSortNavItems(navItems, "asc")
          } else {
            el.classList.remove("is-asc")
            el.classList.add("is-desc")
            demoSortNavItems(navItems, "dsc")
          }
        })
      })
    }

    function demoSortNavItems(navItems, sortDirection) {
      // sort nav item groups by sort direction
      let groups = navItems.querySelectorAll(".edit-nav__group")

      // sort groups by title within .edit-nav__title
      const sortedGroups = Array.from(groups).sort((a: Element, b: Element) => {
      const aTitle = a.querySelector(".edit-nav__title")?.textContent || "";
      const bTitle = b.querySelector(".edit-nav__title")?.textContent || "";

      if (sortDirection === "asc") {
        return bTitle.localeCompare(aTitle);
      } else if (sortDirection === "dsc") {
        return aTitle.localeCompare(bTitle);
      }

      return 0;
    });


      // append sorted groups back to navItems
      sortedGroups.forEach(function (group) {
        navItems.appendChild(group)
      })
    }
    demoSearchToggle()

    demoSortToggle()
  }
  closeEditModal(): void {
    if (this.questionChanged || this.inceptionDateChanged) {
      $("#edit-exit-modal").modal("show");
      return;
    }
    $("#edit-exit-modal").modal("hide");
    const editModal = document.querySelector('.edit-modal');
    editModal.classList.remove('is-active');
    document.querySelector('body').classList.remove('edit-modal-open');
    $('#edit-modal-uw-demo').addClass('d-none');
    $('#edit-modal-review-demo').addClass('d-none');
    $('#edit-modal-nav-review-demo').addClass('d-none');
    $('#edit-modal-uw-tray-demo').addClass('d-none');
    $('#edit-modal-nav-uw-demo').addClass('d-none');
    $('#edit-modal-nav-content-demo').removeClass('d-none');
    $('#edit-modal-changes-tray-demo').addClass('d-none');
    $('#edit-modal-content-demo').removeClass('d-none');
    $('#item-insured-items').addClass('d-none');
    $('#edit-modal-item-empty').removeClass('d-none');
    $('#item-overview-policyholder-details').addClass('d-none');
    $('#item-overview-payment-details').addClass('d-none');
    $('#item-benefits').addClass('d-none');
    //$('#edit-modal-changes-notice-demo').addClass('d-none');

    $(`.active-question-${this.question?.cent_aq_question_id}`).removeClass('mini-flow-card-active');
    $('.edit-modal').removeClass('mini-flow-active');
    $('#review-and-commit-demo-btn').attr('disabled', false);

    document.querySelectorAll('li.is-active').forEach(li => {
      li.classList.remove('is-active');
    });

    this.items = [];
    this.item = null;
    this.resetEditModal();
    editModalGuides()?.close();
  }
  resetEditModal(): void {
    // reset to empty item state
    this.openEditModalItems(null, "items-overview")
    this.openEditModalItem(null, "edit-modal-item-empty")

    // reset to content state
    this.editModalContent.classList.remove("d-none")
    this.editModalReview.classList.add("d-none")
    //this.editModalUW.classList.add("d-none")

    // reset nav state
    document.getElementById("edit-modal-nav-content-demo").classList.remove("d-none")
    document.getElementById("edit-modal-nav-review-demo").classList.add("d-none")
    document.getElementById("edit-modal-nav-uw-demo").classList.add("d-none")

    // remove all active column classes
    this.editModalContent.classList.remove("select-active")
    this.editModalContent.classList.remove("items-active")
    this.editModalContent.classList.remove("item-active")

    // reset all is-active edit-nav items
    this.editModalContent.querySelectorAll(".edit-nav li").forEach(function (el) {
      el.classList.remove("is-active")
    })

    // activate first edit-nav item by default
    this.editModalContent.querySelector(".edit-nav:nth-child(1) li:nth-child(1)").classList.add("is-active")

    // remove all close event listeners
    // document.removeEventListener("keydown", handleEscKeypress)
    // this.editModalBackdrop.removeEventListener("click", closeEditModal)
    // document.querySelectorAll('[data-dismiss="edit-modal"]').forEach(function (el) {
    //   el.removeEventListener("click", closeEditModal)
    // })
  }
  show(item?: any, isReturning: boolean = false): void {
    this.isCalcPremLoading = true;
    this.item = item;
    this.resetEditModal();
    this.switchEditModalState('select-active');
    
    try { this.item.bank_details = JSON.parse(this.item?.bank_details)[0] || []; } catch { }
    //try { this.item.person[0].policy_inception_date = JSON.parse(this.item?.person[0]?.policy_inception_date)[0] || {}; } catch { }
    accounting.settings = {
      currency: {
        symbol: this.item?.currency + ' ' || 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.getClasses();
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.item.session_id);
    parameters.set('person_id', this.person?.person_id.toString());
    this.globalQuestionService.runCommandNew(`getQuestions`, parameters).subscribe(questions => {
      this.questions = questions;
      this.runCalcPremDiff();
      this.globalQuestionService.spinner(false);
      $('#edit-modal-changes-tray-demo').removeClass('d-none');
      // ask the backend whether the session is already dirty on every open - a session
      // reopened with prior uncommitted changes is only knowable from the SP, not the client
      this.policyChangeCheck$.next();
    }, error => {
      console.log(error);
      $('#error-modal').modal('show');
      this.globalQuestionService.spinner(false);
    });
    this.getLocations();
    console.log(this.item,isReturning)
  }
  getLocations(): void {
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.item.session_id);
    parameters.set('group_id', this.item.group_id);
    parameters.set('class_id', '20');
    this.globalQuestionService.runCommandNew(`getResponses`, parameters).subscribe(locations => {
      this.locationData = locations;
      this.locations = locations.filter(l => l.cent_aq_question_id === 1230); // this.groupByAnswer(locations);
      this.globalQuestionService.spinner(false);
     
    }, error => {
     
      this.globalQuestionService.spinner(false);
    });
  }
  groupByAnswer(items): any{
    const grouped = {};

    items.forEach(item => {
      if (item.cent_aq_question_id === 1230) {
        const answer = item.answer;
        if (!grouped[answer]) {
          grouped[answer] = [];
        }
        grouped[answer].push(item);
      }
    });

    return Object.keys(grouped).map(answer => ({
      answer,
      questions: grouped[answer]
    }));
  }
  getClasses(): void {
    this.addons = [];
    this.frequency_id = this.item?.collation?.find(item => item?.entry_type === EntryType.product_selected)?.frequency_id;

    if (!this.frequency_id) {
      this.frequency_id = 3;
    }

    // Setup fees
    this.fees = '';

    if (!this.item) { //isEdit?
      this.item = this.policyQuery.getActive();
    }

    // collation can arrive as null (JSON.parse("null") returns null without throwing,
    // so callers' safe [] defaults get silently overwritten) — for...of null throws.
    for (let c of this.item?.collation || []) {
      if ((c?.entry_type === EntryType.fees || c?.entry_type === EntryType.sasria_subtotal || c?.entry_type === EntryType.taxes) && c?.frequency_id === this.frequency_id) {
        this.fees += c?.description_1 + ' ' + this.accounting?.formatMoney(c?.prem_value) + '<br>';
      }
      if (c?.entry_type === EntryType.class_total && c?.frequency_id === this.frequency_id
        && !this.classes?.some(x => x?.class_id === c?.class_id)) {
        this.classes.push(c);
      }
      if (c?.entry_type === EntryType.item && c?.frequency_id === this.frequency_id
        && !this.items?.some(x => x?.calc_collation_id === c?.calc_collation_id)) {
        this.items.push(c);
      }
      if (c?.entry_type === EntryType.addon && c?.frequency_id === this.frequency_id
        && !this.addons?.some(x => x?.calc_collation_id === c?.calc_collation_id)) {
        this.addons.push(c);
      }
    }
    ///Let add inluded items to items array
    // for (let i of this.item?.included) {
    //     this.addons.push(i);
    // }

    this.addons = this.addons.map(b => {
      const clone = { ...b }; // shallow copy
      clone.class_name = this.classes.find(x => x?.class_id === b?.class_id)?.description_1;
      return clone;
    });
    // this.item.included = this.item.included.map(b => {
    //   const clone = { ...b }; // shallow copy
    //   clone.class_name = this.classes.find(x => x?.class_id === b?.class_id)?.description_1;
    //   return clone;
    // });
    try {
      this.item = {
        ...this.item,
        included: this.item.included.map(b => {
          const clone = { ...b };
          clone.class_name = this.classes.find(x => x?.class_id === b?.class_id)?.description_1;
          return clone;
        })
      };
    }
    catch { }
    try {
      this.included = this.item?.included.reduce((acc, item) => {
        const key = `${item.vaps_name}`;
        const { vaps_name, class_id, vaps_description, ...rest } = item;
        if (!acc[key]) {
          acc[key] = { vaps_name, class_id, vaps_description, items: [] };
        }
        acc[key].items.push(rest);
        return acc;
      }, {});
    }
    catch { }
    //$('#overview').addClass('is-active');
    $('#items-insured-items').addClass('d-none');
   console.log(this.addons,this.included);
    this.itemCount = this.items.filter(item =>
      item.entry_type === 'item' && item.mandatory !== 1
    ).length;

  }
  getClassItems(class_id: number): any {
    return this.items.filter(x => x?.class_id === class_id && x?.mandatory !== 1);
  }
  getBenefitsClasses(): any {
    let classes = [];

    for (const c of this.addons) {
      if (!classes?.some(x => x?.class_id === c?.class_id)) {
        classes.push(c);
      }
    }
    if (this.item?.included) {
      for (const c of this.item?.included) {
        if (!classes?.some(x => x?.class_id === c?.class_id)) {
          classes.push(c);
        }
      }
    }
    
    return classes
  }
  scrollTo(class_id: number): void {
    // Get the element by its ID
    var targetDiv = document.getElementById(class_id.toString());

    // Scroll to the element
    targetDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });

  }
  getDescription(index: number, item: any): string {
    let desc = '';
    try {
      desc = item.split('|')[index];
    }
    catch {
    }
    return desc
  }
  getQuestions(class_id: any, item_id: any): any {
    return this.questions.filter(x => x?.item_id?.toString() === item_id?.toString() && x?.product_class_id?.toString() === class_id?.toString());


    this.globalQuestionService.getResponses()
      .subscribe(r => {
        let questions: Question[];
        questions = r;

        if (questions?.length) {
          this.questions = [];
          this.childrenQuestions = [];
        }
        for (let q of questions) {
          q.isEdit = true;
          if (q?.item_id?.toString() === item_id?.toString() && q?.product_class_id?.toString() === class_id?.toString()) {
            if (q?.parent_control) {
              this.childrenQuestions.push(q);
              const parentQuestion = questions.find(x => x?.cent_aq_question_id === q?.parent_control);
              if (parentQuestion && !this.questions?.some(x => x.cent_aq_question_id === parentQuestion?.cent_aq_question_id)) {
                this.questions.push(parentQuestion);
              }
            } else {
              if (!this.questions?.some(x => x?.cent_aq_question_id === q?.cent_aq_question_id)) {
                this.questions.push(q);
              }
            }
          }
        }
        this.globalQuestionService.spinner(false);
        this.isSavingData = false;
        console.log(this.questions, this.childrenQuestions)
        this.ref.detectChanges();
      }, error => {
        this.globalQuestionService.spinner(false);
        this.isSavingData = false;
      });
  }

  getChildrenQuestions(question: Question): Question[] {
    return this.dependentQuestions.filter(x => x?.parent_control === question?.cent_aq_question_id);
  }
  trackByQuestionId(index: number, question: any): any {
    return question?.cent_aq_question_id;
  }
  subQuestionResponse(event): void {
    //this.answerdQuestions.push(event);
    if (this.answeredQuestions.find(q => q?.cent_aq_question_id === event?.cent_aq_question_id)) {
      this.answeredQuestions.find(q => q?.cent_aq_question_id === event?.cent_aq_question_id).answer = event.answer;
    }
    else {
      this.answeredQuestions.push(event);
    }
    console.log(this.answeredQuestions)
  }
  nextQuestion(): void {

    if (this.answeredQuestions.find(q => q?.cent_aq_question_id === this.currentQuestion?.cent_aq_question_id)) {
      this.answeredQuestions.find(q => q?.cent_aq_question_id === this.currentQuestion?.cent_aq_question_id).answer = this.currentQuestion.answer;
    }
    else {
      this.answeredQuestions.push(this.currentQuestion);
    }
    if (this.item?.session_id !== ''){
    this.globalQuestionService.saveAnswer(this.item?.session_id, this.currentQuestion?.cent_aq_question_id, this.currentQuestion.product_class_id, this.currentQuestion?.item_id, this.currentQuestion?.answer, this.currentQuestion?.answer_id, this.currentQuestion?.comment, this.currentQuestion?.flow_id)
      .subscribe(() => {
      })
    }
    if (this.currentQuestion?.call_proc) {
      this.processing = true
      this.globalQuestionService.runCommand(
        this.globalQuestionService.replaceCallProcParemeters(
          this.currentQuestion?.call_proc,
          this.currentQuestion.item_id,
          this.item?.session_id,
          this.currentQuestion?.class_id,
          this.currentQuestion?.page,
          this.currentQuestion?.flow_id,
          this.currentQuestion?.cent_aq_question_id,
          this.item?.group_id,
          this.item?.category_id
        )).subscribe((val: any[]) => {
          if (val?.length && val[0]?.next) {
            this.flowPlayer.flowQuestions(this.question?.dependant_flow_id, this.item?.category_id, this.item?.session_id, this.item?.group_id, this.question?.item_id)
              .subscribe((flowQuestions: Question[]) => {
                this.dependentQuestions = flowQuestions;
                this.currentQuestion = this.dependentQuestions.find(q => q?.cent_aq_question_id === val[0].next);
                this.currentQuestion.isEdit = true;
                this.getITK();
                this.processing = false;
              });
          }
        })
    }
    else if (this.currentQuestion?.conditions) {
      try {
        let condition = JSON.parse(this.currentQuestion?.conditions)[0];

        let operator = condition.operator;
        if (operator === '=') {
          if (this.currentQuestion?.answer === condition.answer_text) {
            this.currentQuestion = this.dependentQuestions.find(q => q?.cent_aq_question_id === condition?.next);
          }
          else {
            this.currentQuestion = this.dependentQuestions.find(q => q?.cent_aq_question_id === this.currentQuestion?.next);
          }
          this.currentQuestion.isEdit = true;
        }
        else {
          this.currentQuestion = this.dependentQuestions.find(q => q?.cent_aq_question_id === this.currentQuestion?.next);
          this.currentQuestion.isEdit = true;
        }
      }
      catch { }
      this.getITK();
    }
    else {
      this.currentQuestion = this.dependentQuestions.find(q => q?.cent_aq_question_id === this.currentQuestion?.next);
      this.currentQuestion.isEdit = true;
      this.getITK();
    }
    $(`#demo-additional-questions-${this.question?.cent_aq_question_id}`).hide();

    // fade in the next question
    $(`#demo-additional-questions-${this.question?.cent_aq_question_id}`).fadeIn();

  }
  prevQuestion(): void {
    this.currentQuestion = this.dependentQuestions.find(q => q?.next === this.currentQuestion?.cent_aq_question_id);

    this.getITK();
    $(`#demo-additional-questions-${this.question?.cent_aq_question_id}`).hide();

    // fade in the next question
    $(`#demo-additional-questions-${this.question?.cent_aq_question_id}`).fadeIn();
  }
  dependantFlowDone(): void {
    this.processing = true;
    setTimeout(() => {
      $(`#demo-additional-summary-${this.question?.cent_aq_question_id}`).removeClass('d-none');
      $(`#demo-additional-questions-${this.question?.cent_aq_question_id}`).addClass('d-none');
      $(`.active-question-${this.question?.cent_aq_question_id}`).removeClass('mini-flow-card-active');
      $('.edit-modal').removeClass('mini-flow-active');
      $('#review-and-commit-demo-btn').attr('disabled', false);
      this.processing = false;
    }, 2000);

  }
  restartFlow(): void {
    $(`#demo-additional-summary-${this.question?.cent_aq_question_id}`).addClass('d-none');
    $(`#demo-additional-questions-${this.question?.cent_aq_question_id}`).removeClass('d-none');
    this.currentQuestion = this.dependentQuestions.find(q => q?.flow_index === 1);
    this.currentQuestion.isEdit = true;
    this.getITK();
  }
  discardChanges(): void {
    $(`#demo-additional-summary-${this.question?.cent_aq_question_id}`).addClass('d-none');
    $(`#demo-additional-questions-${this.question?.cent_aq_question_id}`).addClass('d-none');
    $('#edit-modal-changes-tray-demo').addClass('d-none');
    //$('#edit-modal-changes-notice-demo').addClass('d-none');
    this.questionChanged = false;
    this.inceptionDateChanged = false;
    this.rollBack();
  }
  reviewCommit(): void {
    
    document.querySelectorAll(".edit-modal__review-body .edit-nav li.has-sub > a").forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault()
        this.parentElement.classList.toggle("is-active")
      })
    })
    editModalGuides()?.close();
    this.changeItems = [];
    this.globalQuestionService.spinner(true);
    let today = new Date().toISOString().split('T')[0];
    const parameters = new Map<string, string>();
    parameters.set('new_session_id', this.item?.session_id);
    parameters.set('policy_id', this.item?.policy_id);
    parameters.set('as_at_date', today.toString());
    this.globalQuestionService.runCommandNew(`getPolicyEditReviewChangesData`, parameters).subscribe(changes => {
      this.changes = changes;
      this.changeProduct = this.changes.find(x => x.entry_type === "overview");
      let changeItems = this.changes.filter(x => x.entry_type === "item");
      let changeBenefits = this.changes.filter(x => x.entry_type === "benefit");  // Confirming it's "Benefit", not "Benefits"
      this.policyHolder = this.changes.filter(x => x.entry_type === "policyholder_details");
      // Helper function to safely parse uw_collation
      function parseUwCollation(entry) {
        if (entry?.uw_collation && typeof entry.uw_collation === 'string') {
          try {
            entry.uw_collation = JSON.parse(entry.uw_collation);
          } catch (e) {
            console.warn(`Failed to parse uw_collation for entry ${entry.id}:`, e);
          }
        }
      }

      // Grouping items by class_id
      let groupedItems = [];
      let currentClassItems = {
        class_id: 0,
        class_name: '',
        items: []
      };

      for (let i = 0; i < changeItems.length; i++) {
        const item = changeItems[i];
        parseUwCollation(item);  // Attempt to parse uw_collation

        if (item.class_id === currentClassItems.class_id) {
          currentClassItems.items.push(item);
        } else {
          if (currentClassItems.items.length) {
            groupedItems.push(currentClassItems);
          }

          // Start new class group
          currentClassItems = {
            class_id: item.class_id,
            class_name: this.classes.find(x => x?.class_id === item.class_id)?.description_1 || '',
            items: [item]
          };
        }
      }

      // Push the last class group if it exists
      if (currentClassItems.items.length) {
        groupedItems.push(currentClassItems);
      }

      this.changeItems = groupedItems;

      // Grouping benefits by class_id
      let groupedBenefits = [];
      let currentClassBenefits = {
        class_id: 0,
        class_name: '',
        items: []
      };

      for (let i = 0; i < changeBenefits.length; i++) {
        const benefit = changeBenefits[i];
        parseUwCollation(benefit);  // Attempt to parse uw_collation

        if (benefit.class_id === currentClassBenefits.class_id) {
          currentClassBenefits.items.push(benefit);
        } else {
          if (currentClassBenefits.items.length) {
            groupedBenefits.push(currentClassBenefits);
          }

          // Start new class group
          currentClassBenefits = {
            class_id: benefit.class_id,
            class_name: this.classes.find(x => x?.class_id === benefit.class_id)?.description_1 || '',
            items: [benefit]
          };
        }
      }

      // Push the last class group if it exists
      if (currentClassBenefits.items.length) {
        groupedBenefits.push(currentClassBenefits);
      }

      this.changeBenefits = groupedBenefits;

      console.log(this.changeProduct, this.changeItems, this.changeBenefits);
      if (this.changeProduct?.uw_flag === 3) {
        $('#edit-modal-uw-demo').removeClass('d-none');
        $('#edit-modal-uw-tray-demo').removeClass('d-none');
        $('#edit-modal-nav-uw-demo').removeClass('d-none');
        $('#edit-modal-nav-content-demo').addClass('d-none');
        $('#edit-modal-changes-tray-demo').addClass('d-none');
        $('#edit-modal-content-demo').addClass('d-none');
        this.uw_collation = this.changeProduct?.uw_collation ? JSON.parse(this.changeProduct.uw_collation) : [];
        this.uw_collation = (this.uw_collation || []).reduce((acc, obj) => {
          const key = obj.product_class;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(obj);
          return acc;
        }, {});
        console.log(this.uw_collation);

      }
      else {
        $('#edit-modal-review-demo').removeClass('d-none');
        $('#edit-modal-content-demo').addClass('d-none');
        $('#edit-modal-nav-review-demo').removeClass('d-none');
        $('#edit-modal-nav-content-demo').addClass('d-none');
        $('#edit-modal-changes-tray-demo').addClass('d-none');
      }
      this.globalQuestionService.spinner(false);
      //this.getClassItemInceptionDates();
    }, error => {
      console.log(error);
      $('#error-modal').modal('show');
      this.globalQuestionService.spinner(false);

    });
  }
  goBackToEdit(): void {
    $('#edit-modal-review-demo').addClass('d-none');
    $('#edit-modal-content-demo').removeClass('d-none');
    $('#edit-modal-nav-review-demo').addClass('d-none');
    $('#edit-modal-nav-content-demo').removeClass('d-none');
    $('#edit-modal-changes-tray-demo').removeClass('d-none');
    //$('#edit-modal-changes-notice-demo').addClass('d-none');
  }
  revertAnswer(): void {
    console.log(this.question)
  }
  questionResponse(event): void {
    console.log(event);
    $(`.class-${event.class_id}-item-${event.item_id}`).addClass('has-notice');
    const selectedQuestion = this.selectedtQuestions.find(q => q?.cent_aq_question_id === event?.cent_aq_question_id);
    selectedQuestion.answer = event.answer;
    this.questionChanged = true;
    $('#edit-modal-changes-tray-demo').removeClass('d-none');
    $('.card__additional').addClass('d-none');
    if (event?.dependant_flow_id) {
      this.question = event;
      $('#modal-additional').modal('show');

    } else {
      const questionIndex = this.questions?.findIndex(question => question?.cent_aq_question_id === event?.cent_aq_question_id);
      if (questionIndex > -1) {
        this.questions[questionIndex] = event;
        this.globalQuestionService.saveIndividualAnswer(this.questions[questionIndex], this.questions[questionIndex].item_id)
          .subscribe(() => {
            if (!this.isSavingData && +this.product?.is_ei_product === 1) {
              this.globalQuestionService.spinner(true);
              this.isSavingData = true;
              this.globalQuestionService.setSummaryDataObservable(true);
              //this.getResponses(this.collation?.class_id ? this.collation?.class_id : 0, this.collation?.session_item_id ? this.collation?.session_item_id : '0');
            } else {
              this.runCalcPremDiff();
              //this.globalQuestionService.spinner(false);
            }
            // Fire on every committed edit. We can't reliably diff the previous answer here:
            // the child controls mutate this.question.answer in place and emit that same object,
            // so `event` is the same reference already held in selectedtQuestions - the old value
            // is gone by the time we get here. Both calls are debounced + switchMapped and the
            // backend is the source of truth, so re-committing an identical value just costs one
            // extra (collapsed) round trip. (product is not bound on the edit modal, so this
            // cannot live behind is_ei_product either.)
            this.policyChangeCheck$.next();
            this.questionsRefresh$.next();
          });
      }
    }
  }
  
  startDependentFlow(): void {
    $(`.${this.question?.cent_aq_question_id}`).removeClass('d-none');
    
    
    $('.edit-modal').addClass('mini-flow-active');

    this.flowPlayer.flowQuestions(this.question?.dependant_flow_id, this.item?.category_id, this.item?.session_id, this.item?.group_id, this.question?.item_id)
      .subscribe((flowQuestions: Question[]) => {
        this.dependentQuestions = flowQuestions;
        this.currentQuestion = this.dependentQuestions.find(q => q?.flow_index === 1);
        $(`#demo-additional-questions-${this.question?.cent_aq_question_id}`).removeClass('d-none');
        $(`.active-question-${this.question?.cent_aq_question_id}`).addClass('mini-flow-card-active');
        this.policyChangeCheck$.next();
        $('#review-and-commit-demo-btn').attr('disabled', true);

        //$('#edit-modal-changes-tray-demo').removeClass('d-none');
        setTimeout(() => {
          editModalGuides()?.init(null, 1);
          const additionalQuestionsContainer = $(`.${this.question?.cent_aq_question_id}.card__additional`)[0];
          // set height of container to 0 before animating the height            
          additionalQuestionsContainer.style.height = "0px"
          additionalQuestionsContainer.style.overflow = "hidden"

          // show container
          additionalQuestionsContainer.classList.remove('d-none');       

          // then animate to the actual height
          additionalQuestionsContainer.style.height = additionalQuestionsContainer.scrollHeight + "px"

          // on transition end, remove the inline styles and scroll to the element if not in view
          additionalQuestionsContainer.addEventListener("transitionend", () => {   

            additionalQuestionsContainer.removeAttribute("style")
                  
            if (!isElementInViewport(additionalQuestionsContainer)) {
              additionalQuestionsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            
          })
         
        }, 500);
      });
  }
  changeClassItem(class_id: number, item_id?: string): void {
    console.log(class_id, item_id)
    this.globalQuestionService.spinner(true);
    if (!item_id) {
      item_id = '0';
    }
    this.activeItemId = item_id;
    this.activeClassId = class_id;
    if (class_id === 0 && item_id === '0') {
      this.collation = null;
    } else {
      this.collation = this.collations.find(c => c.class_id === class_id && c.session_item_id === item_id && c.product_id === this.product?.product_id);
    }
    //this.getResponses(class_id, item_id);
  }

  save(): void {
    this.globalQuestionService.setSummaryDataObservable(true);
    $('#edit-modal').modal('hide');

    // this.sessionDetails = main_session.session;
    // this.question = main_session.question;
    // console.log(this.question);
    // this.questionAnswer.emit(this.question);
    // this.questionStore.setActive(this.question.cent_aq_question_id);
  }

  updateTPQChanges(): void {
    // go to quote-confirm-cover-changes
    this.globalQuestionService.setSummaryDataObservable(true);
    this.globalQuestionService.processTpq()
      .subscribe({
        next: v => {
          $('#edit-modal').modal('hide');
          this.router.navigate([`/${RouterLinks.QuoteConfirmCoverChanges}`]);
        }
      });
  }

  setupCategories(): void {
    this.categories = [];
    if (this.product && this.collations?.length) {
      this.product.price = this.collations.find((p: { entry_type: string, product_id: number, frequency_id: number }) => p?.entry_type === 'premium' && p.frequency_id === this.globalQuestionService?.currency?.frequency_id && p.product_id === this.product?.product_id)?.prem_value;
      this.platform_fee = this.collations.find((p: { entry_type: string, product_id: number }) => p?.entry_type === 'fees_subtotal' && p.product_id === this.product?.product_id);
      this.taxes = this.collations.find((p: { entry_type: string, product_id: number }) => p?.entry_type === 'taxes_subtotal' && p.product_id === this.product?.product_id);
    }
    if (this.collations?.length) {
      for (const c of this.collations) {
        if (c.entry_type === 'product_subtotal' && c.product_id === this.product.product_id) {
          this.product.insurer_rating = [{
            insurer_id: this.product.insurer_id,
            insurer_name: '',
            rating_denom: 0,
            rating_score: 0,
            rating_type: '',
            star_css: '',
            insurer_rating: c.insurer_rating
          }];
        }
        if (!this.categories.some(category => category.class_id === c.class_id) && c.mandatory !== 1) {
          this.categories.push({ class_id: c.class_id, class_name: c.class_name, collations: [] });
        }
      }
    }
    this.categories.sort((a, b) => a.class_id > b.class_id ? 1 : a.class_id < b.class_id ? -1 : 0);
    for (const item of this.categories) {
      item.collations = [];
      for (const c of this.collations) {
        if (this.globalQuestionService.getCount(item.class_id, this.collations) > 0) {
          if (item.class_id === c.class_id && item.class_name === c.class_name && c.product_id === this.product?.product_id && c.frequency_id === this.globalQuestionService?.currency?.frequency_id) {
            let collation: QuoteCollation;
            collation = c;
            let discountList = c.discounts.split(',');

            for (const d of discountList) {
              const dl = d.split(':');
              if (dl[1]) {
                if (discountList?.length) {
                  discountList = [dl[1]];
                } else {
                  discountList.push(dl[1]);
                }
              }
            }

            if (!item.collations?.length) {
              item.collations = [collation];
            } else {
              item.collations.push(collation);
            }
          }
        } else {
          if (item.class_id === 0) {
            item.class_name = 'General';
          }
        }

      }
    }
  }
  moreFlowDone(event: any): void {
    console.log(event);
    //jQuery('#modal-more-mini-flow').modal('hide');
    $('.modal').modal('hide');

  }
  startFlow(): void {

    // const main_session = {
    //   session: this.sessionDetails,
    //   question: this.question,
    //   current_page: 'edit_modal',
    // };
    // localStorage.setItem('main_session', JSON.stringify(main_session));

    // console.log(this.question);
    // $('#modal-more-mini-flow').modal('show');

    this.globalQuestionService.saveAnswer(this.sessionDetails.session_id, 1073, 0, '0', this.path, 0, '')
      .subscribe(result => {
        $('#edit-modal').modal('hide');
        this.flowPlayer.startFlow(0, this.question.dependant_flow_id, this.sessionDetails.category_id, this.sessionDetails.group_id, this.collation.session_item_id, this.sessionDetails.session_id, this.sessionDetails.css, 0);
      },
        err => {
          console.log(err);
        });
  }
  openLocation(location: any): void {
    console.log(location)
  }
  openEditModalItems(event, id, item: any = ''): void {

    if (id == 'items-benefits') this.selectedFilter = 'All benefits';
    else  this.selectedFilter = 'All insured items';
    // close guides
    this.confirmChangesGuide?.close();

    // open item
    const targetItem = document.getElementById(id);
    targetItem.classList.remove('d-none');

    // hide sibling items
    const siblings = Array.from(targetItem.parentElement.children).filter(function (el) {
      return el !== targetItem;
    });
    siblings.forEach(function (el) {
      el.classList.add('d-none');
    });

    if (event !== null) {
      // set active list item state                   
      const targetListItem = event.target.closest('li');
      targetListItem.classList.add('is-active');

      // remove active state from siblings
      const siblingsList = Array.from(targetListItem.parentElement.children).filter(function (el) {
        return el !== targetListItem;
      });
      siblingsList.forEach(function (el) {
        (el as HTMLElement).classList.remove('is-active');
      });
    }
    //$('#edit-modal-content-demo').addClass('items-active');

    //reset item to empty state
    this.openEditModalItem(null, 'edit-modal-item-empty');


    //switch to items-active state
    this.switchEditModalState('items-active');
  }

  openEditModalItem(event, id, item: any = ''): void {
    this.selectedItem = item;
    if (this.selectedItem) {
      if (this.selectedItem?.cent_aq_question_id === 1230) {
          this.selectedtQuestions = this.locationData.filter(l => l.location_id === this.selectedItem?.location_id);
      }
      else {
        this.selectedtQuestions = this.getQuestions(this.selectedItem?.class_id, this.selectedItem?.session_item_id);
      }
    }
    
    //console.log(this.selectedtQuestions);
    //this.getResponses(this.selectedItem?.class_id, this.selectedItem?.session_item_id)
    // close guides
    this.confirmChangesGuide?.close();

    // open item
    const targetItem = document.getElementById(id);
    targetItem.classList.remove('d-none');

    // hide sibling items

    const siblings = Array.from(targetItem.parentElement.children).filter(function (el) {
      return el !== targetItem && el.id !== "edit-modal-changes-notice-demo"
    })
    siblings.forEach(function (el) {
      el.classList.add("d-none")
    })


    if (event !== null) {
      // set active list item state
      const targetListItem = event.target.closest('li');
      targetListItem.classList.add('is-active');

      // remove active state from siblings
      const siblingsList = Array.from(targetListItem.parentElement.children).filter(function (el) {
        return el !== targetListItem;
      });
      siblingsList.forEach(function (el) {
        (el as HTMLElement).classList.remove('is-active');
      });
    }

    // switch to item-active state
    //console.log('switch to item-active state');
    this.switchEditModalState('item-active');

  }
  switchEditModalState(state): void {
    // remove all active column classes
    this.editModalContent = this.editModal.querySelector('.edit-modal__content');
    
    this.editModalContent.classList.remove('select-active');
    this.editModalContent.classList.remove('items-active');
    this.editModalContent.classList.remove('item-active');

    
    // remove is-active classes from respective edit-nav menus
    switch (state) {
      case 'select-active':

        //$('#edit-modal-content-demo').removeClass('items-active');
        //$('#edit-modal-content-demo').addClass('select-active');
        // remove is-active class from edit-nav menu
        const selectNavList = this.editModalContent.querySelector('.edit-modal__content-col:nth-child(1) .edit-nav');
        selectNavList.querySelectorAll('li').forEach(function (el) {
          el.classList.remove('is-active');
        });
        this.editModalContent.classList.add(state);

        break;

      case 'items-active':

        // remove is-active class from edit-nav menu
        const itemsNavList = this.editModalContent.querySelector('.edit-modal__content-col:nth-child(2) .edit-nav');
        itemsNavList.querySelectorAll('li').forEach(function (el) {
          el.classList.remove('is-active');
        });
        this.editModalContent.classList.add(state);

        break;    

      case 'item-active':
        this.editModalContent.classList.add(state);
        break;

      default:
        break;
    }

    // add active class to selected state
   this.menuState = state;
  }
  updateProfile(event: any, item: string): void {
    const person = { ...this.item.person[0] }; // Clone to avoid readonly mutation
    let hasChanged = false;

    switch (item) {
      case 'First Name':
        if (person.first_name !== event) {
          person.first_name = event;
          hasChanged = true;
        }
        break;

      case 'Last Name':
        if (person.last_name !== event) {
          person.last_name = event;
          hasChanged = true;
        }
        break;

      case 'Email':
        if (person.email !== event?.answer && event?.answer !== '') {
          person.email = event.answer;
          hasChanged = true;
        }
        break;

      case 'Mobile':
        if (person.mobile !== event) {
          person.mobile = event;
          hasChanged = true;
        }
        break;

      case 'Birthday':
        if (person.dob !== event) {
          person.dob = event;
          hasChanged = true;
        }
        break;

      case 'Address':
        if (person.address !== event) {
          person.address = event;
          hasChanged = true;
        }
        break;

      default:
        console.warn('Unhandled item type:', item);
        return;
    }

    if (hasChanged) {
      // Create a new array with updated person object
      this.item = {
        ...this.item,
        person: [person]  // Replace person array immutably
      };
      
      this.saveProfile();
    }
  }

  saveProfile(): void {
    if (this.item.person[0]?.first_name && this.item.person[0]?.last_name
      && this.item.person[0]?.email && this.item.person[0]?.mobile
      && this.item.person[0]?.dob && this.item.person[0]?.address) {
      //this.questionService.spinner(true);
      if (this.item.person[0]?.passport_no !== '') {
        this.item.person[0].id_type = 'Passport';
      }
      else {
        this.item.person[0].id_type = 'ID Number';
      }

      
      const parameters = new Map<string, string>();
      parameters.set('session_id', this.item.session_id);
      parameters.set('category_id', this.item.category_id.toString());
      parameters.set('group_id', this.item.group_id.toString());
      parameters.set('person', JSON.stringify(this.item.person[0]));
      this.globalQuestionService.runCommandNew(`saveProfileDetails`, parameters).subscribe(resp => {
        this.questionChanged = true;
        $('#edit-modal-changes-tray-demo').removeClass('d-none');
      }, error => {
        console.log(error);
      });

      // this.policyService.saveProfileDetails(this.policy?.single_person, this.policy?.single_person?.person_id, this.policy.policy_id)
      //   .subscribe(() => {
      //     //this.questionService.spinner(false);
      //   });
    }
  }
  setFilterClass(c: any, type: number): void {
    console.log(c)
    $('.dropdown-item').removeClass('is-active');
    $('.modal-traymenu__list-item').removeClass('is-active');
    if (type === 1) {
      if (c === 'All') {
        $(`.class`).show();
        this.selectedFilter = 'All benefits';
        $('.dd-0').addClass('is-active');
      }
      else {
        $(`.class`).hide();
        this.selectedFilter = c?.class_name;
        $(`.dd-${c?.class_id}`).addClass('is-active');
        $(`.class-${c?.class_id}`).show();
      }
    }
    else {
      if (c === 'All') {
        $(`.class`).show();
        this.selectedFilter = 'All insured items';
        $('.dd-0').addClass('is-active');
      }
      else {
        $(`.class`).hide();
        this.selectedFilter = c?.description_1;
        $(`.dd-${c?.class_id}`).addClass('is-active');
        $(`.class-${c?.class_id}`).show();
      }
    }
    
  }
  getITK(): void {
    if (!this.childrenQuestions) return;
    let itk = '';
    this.currentQuestion.answer_id = 0;

    try { // check itk
      const json = JSON.parse(this.currentQuestion.itk);
      console.log(json)
      itk = json.filter((item: any) => item.answer === this.currentQuestion?.answer)[0]?.itk_comment;
      this.currentQuestion.answer_id = json.filter((item: any) => item.answer === this.currentQuestion?.answer)[0]?.answer_id;
      if (!itk) {
        itk = json.filter((item: any) => item.answer_id === 0)[0]?.itk_comment;
        this.currentQuestion.answer_id = json.filter((item: any) => item.answer_id === 0)[0]?.answer_id;
      }
    }
    catch (e) {
      //console.log(e)
    }

    this.itk = itk;
  }
  addCover(): void {
    console.log(this.item);
    this.globalQuestionService.spinner(true);
    this.globalQuestionService.saveAnswer(this.item.session_id, 1073, 0, '0', '17', 0, '')
      .subscribe(result => {
        this.globalQuestionService.spinner(false);
        localStorage.setItem('previous-document-page', this.router.url);
        const parameters = new Map<string, string>();
        parameters.set('session_id', this.item.session_id);
        this.globalQuestionService.runCommandNew(`getAddItemFlow`, parameters).subscribe(flow => {
          const css = this.item?.category_name.substring(0, this.item?.category_name.indexOf('.')).toLowerCase();
          this.flowPlayer.startFlow(flow[0].superflow_id, flow[0].flow_id, this.item.category_id, this.item.group_id, '0', this.item.session_id, css, 0);
        });

      },
        err => {
          console.log(err);
          this.globalQuestionService.spinner(false);
        });
    // this.router.navigate(['/question-flow']);
  }

  addBenefit(): void {
    //this.store.setActive(this.policy.policy_id);
    //this.store.set([this.policy]);
    const session_id = this.item.session_id;
    const p = this.item;
    let css = this.item?.category_name.substring(0, this.policy?.category_name.indexOf('.')).toLowerCase();
    this.questionFlowSessionStore.update({
      session_id,
      state: 'Pending',
      category_id: p.category_id,
      group_id: p.group_id,
      css
    });
    this.policyStore.set([this.item]);
    this.policyStore.setActive(this.item.policy_id);
    this.globalQuestionService.saveAnswer(this.item.session_id, 1073, 0, '0', '17', 0, '')
      .subscribe(result => {
        localStorage.setItem('previous-document-page', this.router.url);
        this.router.navigate(['/add-benefits']);
      });

  }
  removeBenefit(benefit: any): void {
    console.log(benefit);
    return;
    const parameters = new Map<string, string>();
    parameters.set('class_id', benefit.class_id);
    parameters.set('session_id', benefit.session_id);
    parameters.set('item_id', benefit.session_item_id);
    parameters.set('vaps_id', benefit.product_vaps_id);
    this.globalQuestionService.runCommandNew(`removeBenefit`, parameters).subscribe(result => {
     this.reviewCommit();
    });
  }
  pauseCover(entity?: Entity, item = this.selectedItem, vap = this.selectedVap): void {
    if (entity) {
      this.selectedEntity = entity;
    }

    if (this.selectedEntity === Entity.Policy) {
      this.pausePolicyComponent.showModal(this.selectedEntity);
    } else if (this.selectedEntity === Entity.Item) {
      this.pausePolicyComponent.showModal(this.selectedEntity, item);
    } else if (this.selectedEntity === Entity.Vap) {
      this.pausePolicyComponent.showModal(this.selectedEntity, vap);
    }
  }

  cancelCover(entity?: Entity, item = this.selectedItem, vap = this.selectedVap): void {
    if (entity) {
      this.selectedEntity = entity;
    }
    console.log(entity,item,vap)
    if (this.selectedEntity === Entity.Policy) {
      this.cancelPolicyComponent.showCancelModal(this.selectedEntity,null);
    } else if (this.selectedEntity === Entity.Item) {
      this.cancelPolicyComponent.showCancelModal(this.selectedEntity, item);
    } else if (this.selectedEntity === Entity.Vap) {
      this.cancelPolicyComponent.showCancelModal(this.selectedEntity, vap);
    }
  }

  restoreCover(entity?: Entity, item = this.selectedItem, vap = this.selectedVap): void {
    if (entity) {
      this.selectedEntity = entity;
    }
    if (this.selectedEntity === Entity.Policy) {
      this.restorePolicyComponent.showRestoreModal(this.selectedEntity);
    } else if (this.selectedEntity === Entity.Item) {
      this.restorePolicyComponent.showRestoreModal(this.selectedEntity, item);
    } else if (this.selectedEntity === Entity.Vap) {
      this.restorePolicyComponent.showRestoreModal(this.selectedEntity, vap);
    }
  }

  resumeCover(entity?: Entity, item = this.selectedItem, vap = this.selectedVap): void {
    if (entity) {
      this.selectedEntity = entity;
    }
    if (this.selectedEntity === Entity.Policy) {
      this.resumePolicyComponent.showResumeModal(this.selectedEntity);
    } else if (this.selectedEntity === Entity.Item) {
      this.resumePolicyComponent.showResumeModal(this.selectedEntity, item);
    } else if (this.selectedEntity === Entity.Vap) {
      this.resumePolicyComponent.showResumeModal(this.selectedEntity, vap);
    }
  }

  openPauseCoverFromCancel(value: boolean): void {
    if (value) {
      this.pauseCover();
    }
  }
  onPolicyChange(event: boolean): void {
    if (event) {
      this.reviewCommit();
      // if (this.selectedEntity === Entity.Item || this.selectedEntity === Entity.Vap) {
      //   //this.getPolicy();
      // } else if (this.selectedEntity === Entity.Policy) {
      //   this.router.navigate(['/everything.policies-landing']);
      // }
    }
  }
  rollBack(): void {
    const parameters = new Map<string, string>();
    parameters.set('policy_id', this.item.policy_id);
    parameters.set('curr_session_id', this.item.session_id);
    parameters.set('select', '0');
    parameters.set('rollback', '1');
    this.globalQuestionService.runCommandNew(`editPolicy`, parameters).subscribe(flow => {
      if (this.person.broker_id > 0 || this.person.underwriter || this.person.console_access) {
        this.router.navigate(['/everything.policy-holders']);
      }
      else {
        let fromPage = localStorage.getItem('previous-document-page');
        this.closeEditModal();
        this.router.navigate([fromPage]);
      }
    });

  }
  getClassItemInceptionDates(): void {
    
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.item?.session_id);
    this.globalQuestionService.runCommandNew(`getClassItemInceptionDates`, parameters, false)
      .subscribe(dataset => {
        this.inceptionDates = dataset;
        console.log(this.inceptionDates)
        if (this.inceptionDates.length > 0) {
          setTimeout(() => {
            
            this.globalQuestionService.spinner(false);

          }, 1000);
        }
        else {
          //this.getSummaryOfChanges();
        }
      }, error => {
        //this.getSummaryOfChanges();
      })
  }
  submitPolicyChanges(): void {
    this.globalQuestionService.spinner(true);
    if (!this.inceptionDateChanged) {
      this.policyService.savePolicyUpdate(this.item?.session_id, this.status_id, 0, '0', this.inceptionDate, this.inceptionDate)
        .subscribe({
          next: () => {
            this.policyService.submitPolicyUpdates(this.item?.session_id)
              .subscribe({
                next: () => this.refreshPolicy(),
                error: () => this.globalQuestionService.spinner(false)
              });
          },
          error: (error) => {
            console.log(error);
            $('#error-modal').modal('show');
            this.globalQuestionService.spinner(false);
          }
        });
    } else {
      const parameters = new Map<string, string>();
      parameters.set('session_id', this.item?.session_id);
      parameters.set('policy_id', this.item?.policy_id);
      parameters.set('inception_date', this.inceptionDate);
      parameters.set('user_id', this.person?.person_id?.toString());
      this.globalQuestionService.runCommandNew(`changePolicyInceptionDate`, parameters)
        .subscribe({
          next: () => { this.inceptionDateChanged = false; this.refreshPolicy(); },
          error: (error) => {
            console.log(error);
            this.globalQuestionService.spinner(false);
          }
        });
    }
  }

  private refreshPolicy(): void {
    this.policyService.getPolicies(this.item?.person[0]?.person_id, 0, this.item?.policy_id)
      .subscribe({
        next: (policy: any[]) => {
          if (!policy?.length) { return; }
          const p = policy[0];
          p.benefits = JSON.parse(p?.benefits);
          p.categories = JSON.parse(p?.categories);
          p.parsedClasses = JSON.parse(p?.classes);
          p.collation = JSON.parse(p?.collation);
          p.documents = JSON.parse(p?.documents);
          p.included = JSON.parse(p?.included);
          p.invoices = JSON.parse(p?.invoices);
          p.person = JSON.parse(p?.person);
          try { p.person[0].policy_inception_date = JSON.parse(p?.person[0]?.policy_inception_date)[0] || {}; } catch { }
          p.button_status = JSON.parse(p?.button_status);
          p.parsedRatings = JSON.parse(p?.ratings);
          this.policyStore.set([p]);
          this.policyStore.setActive(p?.policy_id);
          this.questionChanged = false;
          this.closeEditModal();
          setTimeout(() => this.reload.emit(true), 1000);
          Alert('Policy updated succesfully');
          this.globalQuestionService.spinner(false);
        },
        error: () => this.globalQuestionService.spinner(false)
      });
  }

  getType(t: string): any {
    return this.inceptionDates?.filter(i => i?.type === t);
  }
  setDate(event: any, item: any): void {
    let json = {
      "session_id": this.item?.session_id,
      "class_id": item?.class_id,
      "item_id": item?.item_id,
      "date_inception": this.datePipe.transform(event, "dd-MM-yyyy")
    };

    if (!this.json_data.find(v => v.item_id === item?.item_id)) {
      this.json_data.push(json);
    }
    else {
      let i = this.json_data.findIndex(v => v.item_id === item?.item_id);
      this.json_data.splice(i, 1);
      this.json_data.push(json);
    }


  }
  updateInceptionDate(event: any): void {
    const question = new Question();
    const session_id = this.item.session_id;
    const p = this.item;
    this.questionFlowSessionStore.update({
      session_id,
      state: 'Pending',
      category_id: p.category_id,
      group_id: p.group_id,
      flow_id: 0,
    });
    question.cent_aq_question_id = 571;
    question.item_id = '0';
    question.product_class_id = 0;
    question.answer = this.datePipe.transform(event, 'yyyy-MM-dd');
    this.inceptionDateChanged = question.answer !== this.item?.person[0]?.policy_inception_date?.inception_date;
    console.log(this.inceptionDateChanged, question.answer, this.inceptionDate);
    this.inceptionDate = question.answer;
    this.globalQuestionService.saveAnswerOnly(question).subscribe();
  }

  runCalcPremDiff(): void {
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.globalQuestionService.spinner(true);
    this.policyService.calcPremDiff(this.item?.session_id, today)
      .subscribe(response => {
        this.globalQuestionService.spinner(false);
        this.isCalcPremLoading = false;
        this.newItem = response;

        this.premiumCollation = this.newItem?.find(x => x?.entry_type === EntryType.premium && x?.frequency_id === this.frequency_id);
        try {
          this.premiumCollation.description = JSON.parse(this.premiumCollation?.description_json);
        }
        catch (e) {
          console.log(e)
        }

        //this.getSummaryOfChanges();
        //this.getPolicy();
      },
        err => {
          this.globalQuestionService.spinner(false);
          
          const parameters = new Map<string, string>();
          parameters.set('policy_id', this.tempPolicyId);
          parameters.set('person_id', this.person.person_id.toString());
          this.globalQuestionService.runCommandNew(`removePolicyEditVersion`, parameters).subscribe(resp => {
            //this.getPolicy();
          }, error => {
            console.log(error);
          });
          this.item = null;
          $('#error-modal').modal('show');
          $('#error-modal').one('hide.bs.modal', () => {
            this.isCalcPremLoading = false;
           this.closeEditModal();
          });
        });
  }
  checkUW3(items: any): boolean {
    return items.some(item => item?.uw_flag == 3 || item?.uw_action_id == 3);
  }
 hasBenefits(c: number): boolean{
  return this.addons.filter(a => a.class_id === c).length > 0 ;
 }
  openSidesheet(): void {
    $('#help-sidesheet').addClass('is-active');
  }
  openInceptionDateModal(): void {
    //this.getClassItemInceptionDates();
    $('#inception-date-modal').modal('show');
  }
}
